import {SERVICE_URL} from "../api/constants";
import UserController from '../models/user/userController';
import DeviceController from '../models/device/deviceController';

class Util {
}

const exists = (data) => data !== null && data !== undefined;

const empty = (data) => exists(data) && data !== "";

const setEndpoint = (typeName, objecId) => {
  
  let endpoint = SERVICE_URL + '/' + typeName;
  if(exists(objecId)) {
    endpoint += '/' + objecId;
  }
  return endpoint;
};

const setStringValue = (value) => value ? value : "";

const usersFullName = (user) => setStringValue(user.firstName) + " " + setStringValue(user.lastName);

const emptyObject = (object) => Object.keys(object).length === 0;

const statusDry = (item) => !!(exists(item.drynessStatusId) && item.drynessStatusId === DEVICE_DRAYNES_STATUS_ID.DRY);

const statusWet = (item) => !!(exists(item.drynessStatusId) && item.drynessStatusId === DEVICE_DRAYNES_STATUS_ID.WET);

const statusActive = (item) => !!(exists(item.activeStatusId) && item.activeStatusId === DEVICE_ACTIVE_STATUS_ID.ACTIVE);

const statusInactive = (item) => !!(exists(item.activeStatusId) && item.activeStatusId === DEVICE_ACTIVE_STATUS_ID.INACTIVE);

const statusInRange = (item) => !!(exists(item.presenceStatusId) && item.presenceStatusId === DEVICE_PRESENCE_STATUS_ID.IN_RANGE);

const statusOutOfRange = (item) => !!(exists(item.presenceStatusId) && item.presenceStatusId === DEVICE_PRESENCE_STATUS_ID.OUT_OF_RANGE);

const deviceStatusDry = (item) => (statusActive(item) && statusInRange(item) && statusDry(item));

const deviceStatusWet = (item) => (statusActive(item) && statusInRange(item) && statusWet(item));

const deviceWetMoreThanTwentyFourHours = (item) => DeviceController._getTimePassedSinceLastLogInHours(item) >= 24;

const validateEmail = (data) => {
  let emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return emailRegex.test(data);
};

const appTitle = () => {
  let user = UserController._getLoggedInUserFromLocalStorage();
  return user ? "Logged: " + usersFullName(user) : "Pampett";
};

const WINDOW_WIDTH = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

const BREAKPOINT = 768;

const DESKTOP_VIEW = WINDOW_WIDTH > BREAKPOINT;
const MOBILE_VIEW = WINDOW_WIDTH <= BREAKPOINT;

const DEVICE_ACTIVE_STATUS_ID = {
  INACTIVE: 0,
  ACTIVE: 1,
  WRONG: 99
};

const DEVICE_PRESENCE_STATUS_ID = {
  OUT_OF_RANGE: 0,
  IN_RANGE: 1,
  WRONG: 99
};

const DEVICE_DRAYNES_STATUS_ID = {
  WET: 0,
  DRY: 1,
  WRONG: 99
};

const DEVICE_WET_STATUS = {
  SEMI_DRY: 0,
  WET: 1,
  WET_ALERT: 2
};

const USER_ROLE_ID = {
  ADMIN: 1,
  USER: 2,
};

const USER_ROLE_TITLE = {
  ADMIN: 'ADMIN',
  USER: 'USER',
};

const USER_ROLES_SELECT_INPUT = [
  { id: USER_ROLE_ID.ADMIN, name: USER_ROLE_TITLE.ADMIN },
  { id: USER_ROLE_ID.USER, name: USER_ROLE_TITLE.USER }
];

const APP_COLOR = {
  BLUE: "#3a518b",
  RED: "#db0028",
  LIGHT_GRAY: "#d9d7d8",
  GREEN: "#559944"
};

export {
  DEVICE_ACTIVE_STATUS_ID,
  DEVICE_PRESENCE_STATUS_ID,
  DEVICE_DRAYNES_STATUS_ID,
  DEVICE_WET_STATUS,
  USER_ROLE_ID,
  USER_ROLE_TITLE,
  USER_ROLES_SELECT_INPUT,
  APP_COLOR,
  exists,
  empty,
  setEndpoint,
  usersFullName,
  emptyObject,
  statusActive,
  statusInactive,
  statusInRange,
  statusOutOfRange,
  statusDry,
  statusWet,
  deviceStatusDry,
  deviceStatusWet,
  deviceWetMoreThanTwentyFourHours,
  validateEmail,
  appTitle,
  WINDOW_WIDTH,
  BREAKPOINT,
  DESKTOP_VIEW,
  MOBILE_VIEW
}

export default new Util();



// WEBPACK FOOTER //
// ./src/util/util.js